"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriority = void 0;
const types_1 = require("../types");
const getPriority = ({ direction, isActivePolicy, priority, activePriority, }) => {
    if (isActivePolicy) {
        return direction === types_1.ARROW_DIRECTION.UP ? priority - 1 : priority + 1;
    }
    if (direction === types_1.ARROW_DIRECTION.UP) {
        if (activePriority === priority + 1) {
            return priority + 1;
        }
    }
    if (direction === types_1.ARROW_DIRECTION.DOWN) {
        if (activePriority === priority - 1) {
            return priority - 1;
        }
    }
    return priority;
};
exports.getPriority = getPriority;
//# sourceMappingURL=getPriority.js.map